import React, { useState } from 'react';
import './Articles.css';

const ArticleSlide = ({ article, isActive }) => {
  const [showAbstract, setShowAbstract] = useState(false);
  const authors = article.raw.authors.map(a => a.name).join(', ');
  const doi = article.raw.externalIds?.DOI;
  const pdfUrl = article.raw.openAccessPdf?.status === 'GOLD' ? article.raw.openAccessPdf.url : null;

  return (
    <div className={`toolRendersMONAD-articles__slide ${isActive ? 'toolRendersMONAD-articles__slide--active' : ''}`}>
      <a 
        href={article.raw.url} 
        target="_blank" 
        rel="noopener noreferrer" 
        className="toolRendersMONAD-articles__title"
      >
        {article.title}
      </a>
      
      <div className="toolRendersMONAD-articles__authors">{authors}</div>
      <div className="toolRendersMONAD-articles__venue">{article.raw.venue} ({article.raw.year})</div>
      
      <div className="toolRendersMONAD-articles__tags">
        {article.category && (
          <span className="toolRendersMONAD-articles__tag">
            {article.category}
          </span>
        )}
        {article.relevance_score && (
          <span className="toolRendersMONAD-articles__tag">
            {article.relevance_score}
          </span>
        )}
        {pdfUrl && (
          <span className="toolRendersMONAD-articles__tag">
            Open Access
          </span>
        )}
      </div>

      <div className="toolRendersMONAD-articles__tldr">
        <strong>TL;DR:</strong> {article.tldr}
      </div>

      <button 
        onClick={() => setShowAbstract(!showAbstract)} 
        className="toolRendersMONAD-articles__abstract-toggle"
      >
        {showAbstract ? 'Hide' : 'Show'} Abstract
      </button>

      {showAbstract && (
        <div className="toolRendersMONAD-articles__abstract">{article.abstract}</div>
      )}

      <div className="toolRendersMONAD-articles__footer">
        {doi && (
          <a 
            href={`https://doi.org/${doi}`} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="toolRendersMONAD-articles__link"
          >
            DOI
          </a>
        )}
        {pdfUrl && (
          <a 
            href={pdfUrl} 
            target="_blank" 
            rel="noopener noreferrer" 
            className="toolRendersMONAD-articles__link"
          >
            PDF
          </a>
        )}
        <a 
          href={article.raw.url} 
          target="_blank" 
          rel="noopener noreferrer" 
          className="toolRendersMONAD-articles__link"
        >
          Scholar
        </a>
      </div>
    </div>
  );
};

const Articles = ({ data }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  const goToPrev = () => {
    setCurrentIndex(prev => prev > 0 ? prev - 1 : data.articles.length - 1);
  };

  const goToNext = () => {
    setCurrentIndex(prev => prev < data.articles.length - 1 ? prev + 1 : 0);
  };

  const getFirstAuthorInitials = (article) => {
    const firstAuthor = article.raw.authors[0];
    if (!firstAuthor) return '?';
    
    const names = firstAuthor.name.split(' ');
    if (names.length === 1) {
      return names[0].substring(0, 2).toUpperCase();
    }
    return names.map(name => name[0]).join('').substring(0, 2).toUpperCase();
  };

  return (
    <div className="toolRendersMONAD-articles">
 

      <div className="toolRendersMONAD-articles__bubbles">
        {data.articles.map((article, index) => (
          <div
            key={index}
            className={`toolRendersMONAD-articles__bubble ${
              index === currentIndex ? 'toolRendersMONAD-articles__bubble--active' : ''
            }`}
            onClick={() => goToSlide(index)}
            style={{ animationDelay: `${index * 0.05}s` }}
          >
            {getFirstAuthorInitials(article)}
          </div>
        ))}
      </div>
      
      <div className="toolRendersMONAD-articles__slider">
        <button 
          className="toolRendersMONAD-articles__navigation toolRendersMONAD-articles__navigation--prev"
          onClick={goToPrev}
          disabled={data.articles.length <= 1}
        >
          ‹
        </button>
        
        {data.articles.map((article, index) => (
          <ArticleSlide 
            key={article.paperId} 
            article={article} 
            isActive={index === currentIndex}
          />
        ))}
        
        <button 
          className="toolRendersMONAD-articles__navigation toolRendersMONAD-articles__navigation--next"
          onClick={goToNext}
          disabled={data.articles.length <= 1}
        >
          ›
        </button>
      </div>
    </div>
  );
};

export default Articles;